import { RootState } from '../store'

export const getSiteAssistModalState = (state: RootState): boolean => state.siteAssistModal.isOpen
